import { render, staticRenderFns } from "./termination.vue?vue&type=template&id=481b440e&scoped=true"
import script from "./termination.vue?vue&type=script&lang=js"
export * from "./termination.vue?vue&type=script&lang=js"
import style0 from "./termination.vue?vue&type=style&index=0&id=481b440e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481b440e",
  null
  
)

export default component.exports